export const environment = {
  production: false,
  appUrl: 'http://localhost:4200',
  apiUrl: 'https://arx3u2n5ha.us-east-2.awsapprunner.com/api',
};